<div class="as-stretch d-flex row h-100"
     *ngIf="initialized"
     [style.visibility]="!currentVersion? 'hidden': 'visible'">
  <div #viewer class="flex-1"></div>

  <div [style.visibility]="!compareMode || !compareVersion ? 'hidden': 'visible'" #compareViewer
       [ngClass]="!compareMode || !compareVersion? 'flex-0': 'flex-1'"
       class="border-left-dark"></div>
</div>
